import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Cloud = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="89" viewBox="0 0 89 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.8853 0.401253C52.8165 0.401253 58.668 5.02433 60.5246 11.3552C66.345 8.04919 73.8765 8.87746 78.8392 13.8401C83.9051 18.9061 84.6628 26.649 81.1122 32.5159C85.6308 35.3104 88.6413 40.3106 88.6413 46.0138C88.6413 54.7726 81.5409 61.873 72.7821 61.873H16.3667C7.60791 61.873 0.507507 54.7726 0.507507 46.0138C0.507507 40.0742 3.77265 34.8973 8.60592 32.18C6.70826 26.8116 7.90669 20.5934 12.2013 16.2988C17.2242 11.2758 24.8788 10.4883 30.7272 13.9363C31.5814 6.32092 38.042 0.401253 45.8853 0.401253Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
